import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import CityHeroShared from "@/components/CityHeroShared";
import CityMap from "@/components/CityMap";
import CityUseCases from "@/components/CityUseCases";
import MobileBookNowFab from "@/components/MobileBookNowFab";
import VehicleTypeIcons from "@/components/VehicleTypeIcons";
import FleetMeatSection, { ReviewsSection } from "@/components/FleetMeatSection";
import SprinterSpecsSection from "@/components/SprinterSpecsSection";
import SeoLongform from "@/components/SeoLongform";
import GeoAnswerBlock from "@/components/GeoAnswerBlock";
import { FULLERTON_CA_REVIEWS } from "@/data/reviews/fullerton_ca";
import { cityHeadMeta } from "@/data/citySeo";

export const Route = createFileRoute("/fullerton-ca")({
  component: CityLanding,
  head: () => ({
    meta: [
      ...cityHeadMeta("fullerton-ca"),
      { property: "og:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { property: "twitter:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sprinter-van-rentals.com/fullerton-ca" }],
  }),
});

function CityLanding() {
  return (
    <main className="min-h-screen bg-white text-[#0F172A]">
      <Navbar />
      <MobileBookNowFab />
      <CityHeroShared
        citySlug="fullerton-ca"
        cityLabel="Fullerton"
        headline={"Fullerton\nSprinter Van Rentals"}
        intro="Fullerton Sprinter van rentals seating 12 and 15 passengers with full luggage space — delivered across Fullerton and the surrounding Orange County area."
      />
<section id="fleet" className="max-w-[1440px] mx-auto px-6 pt-12 md:pt-16 pb-24 scroll-mt-24">
        <div className="mb-10">
          <p className="font-display font-bold text-xs uppercase tracking-[0.4em] mb-3 text-[#F97316]">Fullerton Sprinter Fleet</p>
          <h2 className="font-display font-black text-5xl md:text-6xl tracking-tight text-[#0F172A]">
            Sprinter vans available to rent in Fullerton.
          </h2>
        </div>
        <VehicleTypeIcons accent="#F97316" citySlug={"fullerton-ca" as never} />
      </section>

      <CityMap citySlug={"fullerton-ca" as never} accent="#F97316" />
      <ReviewsSection city="fullerton-ca" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Fullerton" reviews={FULLERTON_CA_REVIEWS} />
      <SprinterSpecsSection city="fullerton-ca" accent="#F97316" />
      <FleetMeatSection city="fullerton-ca" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Fullerton" />
      <SeoLongform citySlug="fullerton-ca" />
      <GeoAnswerBlock citySlug="fullerton-ca" />
      <CityUseCases citySlug={"fullerton-ca" as never} accent="#F97316" />
      <footer className="py-8 text-center border-t border-[#0F172A]/8">
        <p className="text-[#0F172A]/50 text-xs tracking-widest uppercase">&copy; 2026 Sprinter Van Rentals · Fullerton</p>
      </footer>
    </main>
  );
}
